import LogoIconDashBobs from "@/ui/assets/images/DashBobs/logo-dash_bobs.png";
import { DIValidators, EFeatureFlags } from "@/core/@types/types";
import { diContainer } from "@/inversify.config";
import { IF360FeatureFlagValidator } from "@/core/validators/F360FeatureFlagValidator";
import { sendDashBobMenuAnalytics } from "../composables/useDahsBobsAnalytics";

const hasDashBobsFeatureFlag = () => {
  return diContainer
    .get<IF360FeatureFlagValidator>(DIValidators.FEATURE_FLAGS)
    .handleValidationByName(EFeatureFlags.DashBobs);
};

export const getRouterConfigDashBobs = () => {
  return {
    menuLabel: "Dash Bob's",
    customClass: "DashBobs-sidebar",
    img: LogoIconDashBobs,
    routerConfig: async () => {
      // Analytics não deve interromper a abertura da URL
      try {
        await Promise.resolve(sendDashBobMenuAnalytics());
      } catch (error) {
        console.error("[RouterDashBobs] Erro ao enviar analytics:", error);
      }

      // Tratamento de popup bloqueado
      const url = "https://mundobobs.com.br";
      const popup = window.open(url, "_blank");

      if (!popup) {
        console.error("[RouterDashBobs] Popup bloqueado, usando fallback");
        window.location.href = url;
      }
    },
    validator: [hasDashBobsFeatureFlag()]
  };
};
